function formatDate(dateString) {
  const year = dateString.substring(0, 4);
  const month = parseInt(dateString.substring(4, 6), 10) - 1; // 월은 0부터 시작하므로 1을 빼줍니다.
  const day = dateString.substring(6, 8);

  const date = new Date(year, month, day);
  const options = { weekday: "short", month: "short", day: "numeric" };

  return date.toLocaleDateString("ko-KR", options);
}

export { formatDate };
